"use client";

import { useEffect, useState } from "react";
import { CrmShell } from "@/features/crm/crm-shell";
import { ClientsView } from "@/features/crm/clients-view";
import { TasksView } from "@/features/crm/tasks-view";
import { RemindersView } from "@/features/crm/reminders-view";
import { ReportsView } from "@/features/crm/reports-view";
import { AuthView } from "@/features/crm/auth-view";
import { PipelineLiveView } from "@/features/crm/pipeline-live-view";
import { AdminLiveView } from "@/features/crm/admin-live-view";
import { DashboardLiveView } from "@/features/crm/dashboard-live-view";

export default function HomePage() {
  const [activeRoute, setActiveRoute] = useState("Обзор");
  const [signedIn, setSignedIn] = useState(false);
  const [setup, setSetup] = useState<boolean | null>(null);
  useEffect(() => {
    fetch("/api/setup/status")
      .then((response) => response.json())
      .then((data) => {
        setSetup(data.needsSetup);
        if (!data.needsSetup)
          fetch("/api/auth/session")
            .then((response) => response.json())
            .then((session) => setSignedIn(Boolean(session.user)));
      });
  }, []);
  if (setup === null)
    return (
      <section className="auth-view" data-amazi-id={"crm/src/app/page.tsx:31:7"}>
        <div className="auth-card" data-amazi-id={"crm/src/app/page.tsx:32:9"}>
          <div className="brand-mark" data-amazi-id={"crm/src/app/page.tsx:33:11"}>N</div>
          <h1 data-amazi-id={"crm/src/app/page.tsx:34:11"}>Подключаем Nexora</h1>
          <p data-amazi-id={"crm/src/app/page.tsx:35:11"}>Проверяем состояние рабочего пространства…</p>
        </div>
      </section>
    );
  if (!signedIn)
    return (
      <AuthView
        setup={setup}
        onSignIn={async (role, values) => {
          const response = await fetch(setup ? "/api/setup" : "/api/auth/login", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...values, role }),
          });
          if (!response.ok) return (await response.json()).error ?? "Не удалось выполнить вход";
          setSignedIn(true);
          setSetup(false);
          setActiveRoute(role === "administrator" ? "Администрирование" : "Обзор");
        }} data-amazi-jsx-id={"crm/src/app/page.tsx:41:7"}
      />
    );
  const view =
    activeRoute === "Заказы" ? (
      <PipelineLiveView data-amazi-jsx-id={"crm/src/app/page.tsx:58:7"} />
    ) : activeRoute === "Клиенты" ? (
      <ClientsView data-amazi-jsx-id={"crm/src/app/page.tsx:60:7"} />
    ) : activeRoute === "Задачи мастеров" ? (
      <TasksView data-amazi-jsx-id={"crm/src/app/page.tsx:62:7"} />
    ) : activeRoute === "Напоминания" ? (
      <RemindersView data-amazi-jsx-id={"crm/src/app/page.tsx:64:7"} />
    ) : activeRoute === "Отчёты" ? (
      <ReportsView data-amazi-jsx-id={"crm/src/app/page.tsx:66:7"} />
    ) : activeRoute === "Администрирование" ? (
      <AdminLiveView data-amazi-jsx-id={"crm/src/app/page.tsx:68:7"} />
    ) : (
      <DashboardLiveView data-amazi-jsx-id={"crm/src/app/page.tsx:70:7"} />
    );
  return (
    <CrmShell
      activeRoute={activeRoute}
      onNavigate={(route) => (route === "Вход" ? setSignedIn(false) : setActiveRoute(route))}
     data-amazi-jsx-id={"crm/src/app/page.tsx:73:5"}>
      {view}
    </CrmShell>
  );
}
